/* eslint-disable no-useless-constructor */
import { Component } from "react";
// import { sanitize } from 'dompurify';
import DOMPurify from "dompurify";
const sanitize = DOMPurify.sanitize;

class HTMLNootBookAI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notebookItems: [],
        }
    }
    componentWillMount() {
        if (this.props.notebookItems) {
            let { notebookItems } = this.props;
            this.setState({ notebookItems });
        }
    }
    renderChatConversation = () => {
        let { notebookItems } = this.state;
        return (
            <>
                {( notebookItems.map( x => <div className="chat-body" style={{ background: '#ffff' }}>
                    {(x.user_question) && <div style={{ padding: '4px 8px', marginBottom: '10px', background: "#d3cece" }}>
                        <span style={{ padding: '4px 8px', fontSize: '14px' }}>Question:</span>
                        <span style={{ textAlign:'left', alignItems:'left'}}>{x.user_question}</span>
                    </div>}
                    <div style={{ border: '1px solid #EB1700', padding: '8px 12px', margin: '10px 0px' , borderRadius:'10px' }}>
                        { x.user_summary ? <div style={{ fontSize: '14px' , textAlign:'left' }} 
                        dangerouslySetInnerHTML={{ __html: sanitize(x.user_summary) }}></div>:
                        <div style={{ fontSize: '14px' , textAlign:'left' }} 
                        dangerouslySetInnerHTML={{ __html: sanitize(x.user_notes) }}></div>}
                    </div>
                </div>))}
            </>
        )
    }
    render() {
        return (
            <div style={{ width: "100%" }}>
                <div style={{ width: "100%", textAlign: "center", fontSize: "18px", fontFamily: "Verdana" }}><b>{this.props.notebookName}</b></div>
                {this.renderChatConversation()}
            </div>
        );
    }

}
export default HTMLNootBookAI;